<template>
	<div class='publicExport'>
		<el-dialog title="导出设置" :visible.sync="isShow" width="520px" :close-on-click-modal="false" id='printDialog_ss'>
        <div class='print_container'>
          
           <div>
            <span class='printTitle'>导出类型：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                 <el-radio v-model="printFormData.exportScope" label="1">当前科目</el-radio>
                 <el-radio v-model="printFormData.exportScope" label="2">全部</el-radio>
            </div>
            
          </div>
          <div style='margin-top: 20px;'>
            <span class='printTitle'>导出范围：</span>
            <div style='margin-top: 20px;margin-left: 10px;'>
                 <el-radio v-model="printFormData.exportType" label="1">导出Excel</el-radio>
                 <el-radio v-model="printFormData.exportType" label="2">导出单据PDF</el-radio>
            </div>
            
          </div>
          <div style='margin-top: 20px;text-align: right;'>
            <el-button size="small" class='minButton' @click='handlePrint'>导出</el-button>
          </div>
        </div>
      </el-dialog>
	</div>
</template>
<script>
	export default {
		props:{
			exportDialogShow:Boolean
		},
		data() {
			return {
				printFormData:{
					exportScope:"1",
					exportType:"1"
				}
			}
		},
		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.exportDialogShow;
				},
				set (val) {
					this.$emit('update:exportDialogShow', val);
				}
			},
		},
		methods:{
			handlePrint() {
				this.$emit('clickExport',this.printFormData)
			}
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/publicExport.vue